import React, { useState,useEffect } from 'react';

const CuisinesAndTiming = ({ cuisineArray, setCuisineArray ,timingArray , setTimingArray }) => {


  const [enteredCuisine, setEnteredCuisine] = useState('');
  const [enteredTime, setEnteredTime] = useState('');

  const [activeTimingDay, setactiveTimingDay] = useState(0);


  const [activeTimingArray, setActiveTimingArray] = useState([]);



  const saveCuisine = () => {
    if (enteredCuisine == '') {
      return;
    }
    let temp = [...cuisineArray, enteredCuisine];
    setCuisineArray(temp);
    setEnteredCuisine('')
  }

  const deleteCuisine = (index) => {
    let temp = [...cuisineArray];
    temp.splice(index, 1);
    setCuisineArray(temp)
  }

  const changeTimingDay=(index)=>{

    setactiveTimingDay(index) ;
    console.log('Array choosen is', timingArray[index-1])
    setActiveTimingArray(timingArray[index-1]) ;

  }


const removeTiming = (index) => {
  let temp = [...activeTimingArray];
  
  temp.splice(index, 1);
  setActiveTimingArray(temp)
  setTimingArray([...timingArray,temp])
  
}


//make a function that takes a string and adds it into active timing array as well as into the timing array based on active timing day
const saveTiming = () => {
  if (enteredTime == '') {
    return;
  }
  let temp = [...activeTimingArray];
  temp.push(enteredTime);
  let allTimeArray = [...timingArray];

  allTimeArray[activeTimingDay-1].push(enteredTime);
  setTimingArray(allTimeArray)

  setActiveTimingArray(temp) ;
  setEnteredTime('')
}


  return (
    <div className="p-3  my-4">
      <div className="mt-8 p-4 flex justify-between">



      <div class="border w-70% border-gray-300 rounded-sm bg-white p-4 ">

<p className="font-bold text-gray-600 text-lg leading-8 uppercase h-6 mx-2 mb-2">
  Restaurant Timings
</p>

<span className="my-3 mt-8 flex justify-between items-center  w-70%">

<span onClick={()=>changeTimingDay(1)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==1 && 'text-white bg-indigo-500'}`}>Monday</span>
<span onClick={()=>changeTimingDay(2)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==2 && 'text-white bg-indigo-500'}`}>Tuesday</span>
<span onClick={()=>changeTimingDay(3)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==3 && 'text-white bg-indigo-500'}`}>Wednesday</span>
<span onClick={()=>changeTimingDay(4)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==4 && 'text-white bg-indigo-500'}`}>Thursday</span>
<span onClick={()=>changeTimingDay(5)} className={`mx-2 bg-gray-200  cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==5 && 'text-white bg-indigo-500'}`}>Friday</span>
<span  onClick={()=>changeTimingDay(6)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==6 && 'text-white bg-indigo-500'}`}>Saturday</span>
<span  onClick={()=>changeTimingDay(7)} className={`mx-2 bg-gray-200 cursor-pointer text-xs rounded-md p-2 ${activeTimingDay==7 && 'text-white bg-indigo-500'}`}>Sunday</span>

</span>




<div className="flex items-center justify-between border-b border-teal-500 py-2   mt-8">
  <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 flex-1 focus:outline-none"
    type="text" value={enteredTime} onChange={(e) => setEnteredTime(e.target.value)} placeholder="Enter New Timing"  />
  <button onClick={() => saveTiming()} className="bg-green-500 w-auto text-white rounded-sm px-4 py-2 " >
    Add Time Slot
  </button>
</div>

<div className="mt-4 flex flex-wrap  items-center">

  {activeTimingArray && activeTimingArray.map((item, index) => {
    return (
      <div key={index} className="flex mt-4 items-center bg-purple-500 text-white   px-3 py-2 mr-3 rounded-lg ">
      
        <input value={item} className="mr-1 bg-transparent border-gray-50 border-b px-2 w-40"/>
        <svg onClick={() => removeTiming(index)} width="16" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className="fill-current" d="M13.5 4H11.5V2.75C11.5 2.19844 11.0516 1.75 10.5 1.75H5.5C4.94844 1.75 4.5 2.19844 4.5 2.75V4H2.5C2.22344 4 2 4.22344 2 4.5V5C2 5.06875 2.05625 5.125 2.125 5.125H3.06875L3.45469 13.2969C3.47969 13.8297 3.92031 14.25 4.45312 14.25H11.5469C12.0813 14.25 12.5203 13.8313 12.5453 13.2969L12.9312 5.125H13.875C13.9438 5.125 14 5.06875 14 5V4.5C14 4.22344 13.7766 4 13.5 4ZM10.375 4H5.625V2.875H10.375V4Z" />
        </svg>
      </div>
    )
  })}

</div>

</div>



        <div class="w-30% border ml-5  border-gray-300 rounded-sm bg-white p-4 ">

          <p className="font-bold text-gray-600 text-lg leading-8 uppercase h-6 mx-2 mt-3">
            Cusines in Restaurant
          </p>


          <div className="flex items-center justify-between  border-b border-teal-500 py-2   mt-8">
            <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 flex-1 focus:outline-none"
              type="text" defaultValue={enteredCuisine} onChange={(e) => setEnteredCuisine(e.target.value)} placeholder="Name of Cuisine" aria-label="Full name" />
            <button onClick={() => saveCuisine()} className="bg-green-500 w-auto text-white rounded-sm px-4 py-2 " >
              Add Item
            </button>
          </div>

          <div className="mt-4 flex  flex-wrap items-center">

            {cuisineArray && cuisineArray.map((item, index) => {
              return (
                <div key={index} className="flex items-center bg-yellow-600 text-white px-3 py-2 mr-3 rounded-lg ">
                  <p className="mr-1">{item}</p>
                  <svg onClick={() => deleteCuisine(index)} width="16" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="fill-current" d="M13.5 4H11.5V2.75C11.5 2.19844 11.0516 1.75 10.5 1.75H5.5C4.94844 1.75 4.5 2.19844 4.5 2.75V4H2.5C2.22344 4 2 4.22344 2 4.5V5C2 5.06875 2.05625 5.125 2.125 5.125H3.06875L3.45469 13.2969C3.47969 13.8297 3.92031 14.25 4.45312 14.25H11.5469C12.0813 14.25 12.5203 13.8313 12.5453 13.2969L12.9312 5.125H13.875C13.9438 5.125 14 5.06875 14 5V4.5C14 4.22344 13.7766 4 13.5 4ZM10.375 4H5.625V2.875H10.375V4Z" />
                  </svg>
                </div>
              )
            })}

          </div>

        </div>



      


      </div>
    </div>
  );
}

export default CuisinesAndTiming;
